import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsletterSignup from "../components/NewsletterSignup";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";
import { Article, ArrowRight, Calendar } from "@phosphor-icons/react";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useSEO({
    title: "Blog — Hiring Tips, Trade Insights & Canadian Service Marketplace News",
    description: "Read the latest guides, tips, and stories for Canadian customers and skilled workers. From hiring a plumber to growing your trade business.",
    path: "/blog",
  });

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">The CanHireSolution Blog</div>
        <h1 className="font-display text-5xl sm:text-6xl mb-3">Stories, tips & news.</h1>
        <p className="text-base text-slate-600 max-w-xl mb-12">For customers hiring help and pros growing their business — across Canada.</p>

        {loading ? (
          <div className="text-slate-500">Loading…</div>
        ) : posts.length === 0 ? (
          <div className="border border-dashed border-slate-300 p-12 text-center">
            <Article size={32} className="mx-auto text-slate-400 mb-2" />
            <p className="text-slate-600">No posts yet — check back soon.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`blog-card-${p.slug}`}>
                {p.cover_image && (
                  <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                  </div>
                )}
                <div className="p-5">
                  {p.tags?.length > 0 && (
                    <div className="text-[10px] uppercase tracking-wider font-semibold text-accent-red mb-2">{p.tags[0]}</div>
                  )}
                  <h2 className="font-display text-xl mb-2 group-hover:text-brand">{p.title}</h2>
                  <p className="text-sm text-slate-600 line-clamp-3 mb-4">{p.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-slate-500">
                    <span className="flex items-center gap-1"><Calendar size={12} /> {new Date(p.published_at).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" })}</span>
                    <span className="flex items-center gap-1 font-semibold text-brand">Read <ArrowRight size={12} weight="bold" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="mt-20 border-t border-slate-200 pt-12">
          <NewsletterSignup source="blog" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
